
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Fréjus dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Fréjus certifiée Google Partner, soutient les entreprises fréjusiennes pour booster leur notoriété en ligne et capter de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Fréjus dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Fréjus certifiée Google Partner, soutient les entreprises fréjusiennes pour booster leur notoriété en ligne et capter de nouveaux clients.",
        },
      ],
    };
  },
};
